// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Vhb8W","signatureButtonsRight":"ModalSign_signatureButtonsRight__2YeLO"};